import { put, takeLatest } from 'redux-saga/effects'
import {
    GET_RESETPASSWORD_USERINFO,
    GET_RESETPASSWORD_USERINFO_SUCCESSED,
    GET_RESETPASSWORD_USERINFO_FAILED,
    UPDATE_RESETPASSWORD_USERINFO,
    UPDATE_RESETPASSWORD_USERINFO_SUCCESSED,
    SAVE_RESETPASSWORD,
    SAVE_RESETPASSWORD_FAILED,
    SAVE_RESETPASSWORD_SUCCESSED
} from '../actions/actionTypes'
import { ApiService } from '../services/ApiService'


const _apiService = new ApiService()

function* fetchResetPasswordUserInfo(action) {
  try {
    let response = yield _apiService.getUserInformation(action.params.refnum)
    if (!response || response.error) {
      //Show information error when user ref is not exist
      if(response.error.indexOf('does not exist')>-1){
        yield put({
          type: GET_RESETPASSWORD_USERINFO_FAILED,
          message: response.error,
          infoError: response.error,
          data: Object.assign({
          }, { message: response.error, description: response.error })
        })
      }else if (response && response.errorData && response.errorData.response && response.errorData.response.data && response.errorData.response.data.message) {
        var responseErrMsg = response.errorData.response.data.message
        var description = response.errorData.response.data.description
    
        yield put({
          type: GET_RESETPASSWORD_USERINFO_FAILED,
          message: responseErrMsg,
          infoError: responseErrMsg,
          data: Object.assign({
          }, { message: responseErrMsg, description: description })
        })
      } else {
        yield put({

          type: GET_RESETPASSWORD_USERINFO_FAILED,
          message: response.error || 'An error has occurred'
        })
      }
    } else {
      if(response.challengeQuestions){
        yield put({
          type: GET_RESETPASSWORD_USERINFO_SUCCESSED,
          data: Object.assign({
          }, response, { 
              questions:[{label:response.challengeQuestions[0],value:response.challengeQuestions[0]},
              {label:response.challengeQuestions[1],value:response.challengeQuestions[1]},
              {label:response.challengeQuestions[2],value:response.challengeQuestions[2]}],
              question:response.challengeQuestions[0],
          answer:null,password:null,confirmpassword:null,refnum:action.params.refnum})
        })
      }else{
        var message = "The security questions have not been setup for your account. Please contact the helpdesk 718-999-2611 to reset your password."
        yield put({
          type: GET_RESETPASSWORD_USERINFO_FAILED,
          message: message,
          infoError: message,
          data: Object.assign({
          }, { message: message, description: message })
        })
      }
      
    }
  } catch (error) {
    yield put({
      type: GET_RESETPASSWORD_USERINFO_FAILED,
      message: error.message
    })
  }
}

export function* watchFetchResetPasswordUserInfo() {
  yield takeLatest(GET_RESETPASSWORD_USERINFO, fetchResetPasswordUserInfo)
}



function* updateResetPasswordUserInfo(action) {
        yield put({
          type: UPDATE_RESETPASSWORD_USERINFO_SUCCESSED,
          data: Object.assign({
          }, {} , action.params)
        })
}
  
export function* watchResetPasswordUpdateUserInfo() {
    yield takeLatest(UPDATE_RESETPASSWORD_USERINFO, updateResetPasswordUserInfo)
}

function* saveResetPassword(action) {
  try {
    let payload = {
    userLogin:action.params.userLogin,
    newPassword:action.params.confirmpassword, 
    challengeQuestions:[
      {name:action.params.question,value:action.params.answer},
    ]}
    
    let response = yield _apiService.resetPassword(payload)
    if (!response || response.error) {
        if (response && response.errorData && response.errorData.response && response.errorData.response.data && response.errorData.response.data.message) {
          var responseErrMsg = response.errorData.response.data.message
          var description = response.errorData.response.data.description
          yield put({
            type: SAVE_RESETPASSWORD_FAILED,
            message: responseErrMsg,
            infoError: responseErrMsg,
            data: Object.assign({
            }, { message: responseErrMsg, description: description })
          })
        } else {
          yield put({
            type: SAVE_RESETPASSWORD_FAILED,
            message: response.error || 'An error has occurred'
          })
        }
      } else {
      yield put({
        type: SAVE_RESETPASSWORD_SUCCESSED,
        data: Object.assign({
        }, action.params,response)
      })
    }
  } catch (error) {
    yield put({
      type: SAVE_RESETPASSWORD_FAILED,
      message: error.message
    })
  }
}

export function* watchSaveResetPassword() {
  yield takeLatest(SAVE_RESETPASSWORD, saveResetPassword)
}